export default {

    getQuoteRequestStatus: {
        method: 'get',
        url: '/client/dashboard/sales/status-quote-request'
    },
    getDataQuoteRequestStatus: {
        method: 'get',
        url: '/client/dashboard/sales/data-status-quote-request?status=STATUS'
    },

    getQuoteStatus: {
        method: 'get',
        url: '/client/dashboard/sales/status-quote'
    },
    getDataQuoteStatus: {
        method: 'get',
        url: '/client/dashboard/sales/data-status-quote?status=STATUS'
    },

    timelyAlertCreationTrackingOperation: {
        method: 'get',
        url: '/client/dashboard/sales/time-alert-creation-tracking-operation'
    },
    dataTimelyAlertCreationTrackingOperation: {
        method: 'get',
        url: '/client/dashboard/sales/data-time-alert-creation-tracking-operation?type=TYPE'
    }
}
